import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const PlannerPlus: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      width="28" 
      height="28" 
      viewBox="0 0 56 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M27.9969 55.4284C26.3739 55.4284 25.0582 54.1127 25.0582 52.4897V30.9386H3.50713C1.88409 30.9386 0.568359 29.6229 0.568359 27.9999C0.568359 26.3768 1.88409 25.0611 3.50714 25.0611H25.0582V3.51006C25.0582 1.88702 26.3739 0.571289 27.9969 0.571289C29.62 0.571289 30.9357 1.88702 30.9357 3.51007V25.0611H52.4867C54.1098 25.0611 55.4255 26.3768 55.4255 27.9999C55.4255 29.6229 54.1098 30.9386 52.4867 30.9386H30.9357V52.4897C30.9357 54.1127 29.62 55.4284 27.9969 55.4284Z" 
        fill="#3273E1" 
        fillOpacity="0.98"
      />
    </svg>
  </SvgWrapper>
);
